import { create } from 'zustand';
import { logEvent } from '@/utils/analytics';
import React from 'react';


export type ModalProps = Record<string, unknown>;

export type ModalComponent<P extends ModalProps = ModalProps> = React.ComponentType<P & { onCloseAction: () => void }>;

export interface ModalEntry<P extends ModalProps = ModalProps> {
  id: string;
  component: ModalComponent<P>;
  props: P;
}

interface ModalState {
  modals: ModalEntry[];
  openModal: <P extends ModalProps>(
    component: ModalComponent<P>,
    props: P
  ) => string;
  closeModal: (id: string) => void;
  closeAll: () => void;
}

export const useModalStore = create<ModalState>((set) => ({
  modals: [],
  openModal: (component, props) => {
    const id = `modal_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`;
    logEvent('modal_open', { id, component: component.displayName || component.name });
    set((s) => ({
      modals: [...s.modals, { id, component, props }],
    }));
    return id;
  },
  closeModal: (id) => {
    logEvent('modal_close', { id });
    set((s) => ({
      modals: s.modals.filter((m) => m.id !== id),
    }));
  },
  closeAll: () => {
    logEvent('modal_close_all', {});
    set({ modals: [] });
  },
}));
